function creditExpiry(credit) {
  return credit?.expiryDate || credit?.dateOfExpiry || null;
}

function isEligibleTravelCredit(credit) {
  if (!credit) {
    return false;
  }
  if (credit.applied === true || credit.isApplied === true) {
    return false;
  }
  const expiry = creditExpiry(credit);
  return !expiry || new Date(expiry) > new Date();
}

function pickOneTravelCredit(credits) {
  const eligible = (credits || []).filter(isEligibleTravelCredit);
  if (!eligible.length) {
    return null;
  }

  return [...eligible].sort((a, b) => {
    const amountDiff = Number(b.amount) - Number(a.amount);
    if (amountDiff !== 0) {
      return amountDiff;
    }
    const expiryA = creditExpiry(a);
    const expiryB = creditExpiry(b);
    if (!expiryA && !expiryB) {
      return 0;
    }
    if (!expiryA) {
      return 1;
    }
    if (!expiryB) {
      return -1;
    }
    return new Date(expiryA) - new Date(expiryB);
  })[0];
}

/** mirrors TravelCreditSelection.PickForBooking: every credit when they all share one category, otherwise the single pickOne choice */
export const pickTravelCreditsForBooking = credits => {
  const eligible = (credits || []).filter(isEligibleTravelCredit);
  const sameCategory = eligible.length && eligible[0].category && eligible.every(credit => credit.category === eligible[0].category);
  return sameCategory ? eligible : [pickOneTravelCredit(eligible)].filter(Boolean);
};
